var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11912_4360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.334 5V11.6667C23.334 12.1087 23.5096 12.5326 23.8221 12.8452C24.1347 13.1577 24.5586 13.3333 25.0007 13.3333H31.6673",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.334 35H11.6673C10.7833 35 9.93542 34.6488 9.31029 34.0237C8.68517 33.3986 8.33398 32.5507 8.33398 31.6667V8.33333C8.33398 7.44928 8.68517 6.60143 9.31029 5.97631C9.93542 5.35119 10.7833 5 11.6673 5H23.334L31.6673 13.3333V31.6667C31.6673 32.5507 31.3161 33.3986 30.691 34.0237C30.0659 34.6488 29.218 35 28.334 35Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.666 20L23.3327 26.6667M23.3327 20L16.666 26.6667",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11912_4360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFiles);
export default __webpack_public_path__ + "static/media/noFiles.271e7ac3097dadd53df22fdad5ae349d.svg";
export { ForwardRef as ReactComponent };